import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
export function CommerceHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-742">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-743">
        <MapPin className="w-4 h-4" data-id="element-744" />
        Serving Commerce, MI
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-745">
        Taekwondo Classes & Martial Arts Programs Near Commerce, MI
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-746">
        Storm Taekwondo welcomes students from Commerce Township who are looking
        for a higher standard of martial arts instruction in a modern,
        family-friendly facility.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-747">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-748">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-749">
          Call 517-220-0621
        </a>
      </div>
    </div>;
}